import { render } from "./DynamicKnob.vue?vue&type=template&id=2080e62d&ts=true"
import script from "./DynamicKnob.vue?vue&type=script&lang=ts"
export * from "./DynamicKnob.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicKnob.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2080e62d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2080e62d', __exports__)) {
    api.reload('2080e62d', __exports__)
  }
  
  module.hot.accept("./DynamicKnob.vue?vue&type=template&id=2080e62d&ts=true", () => {
    api.rerender('2080e62d', render)
  })

}


export default __exports__